export default __webpack_public_path__ + "static/media/2.0cbc1a8c.jpg";